import { useMemo } from "react";
import { QUERY_CACHE_TIME, REQUEST_ID } from "@sablier/v2-constants";
import { _ } from "@sablier/v2-mixins";
import { Plugin } from "@sablier/v2-models";
import { useQuery } from "@tanstack/react-query";
import type { IAddress } from "@sablier/v2-types";

interface Params {
  chainId: number | undefined;
  expected?: IAddress | undefined;
  name: Parameters<typeof Plugin.isInstalled>["0"]["name"];
  proxy: string | undefined;
  registry: string;
}

export default function useCheckPlugin(params: Params) {
  const { chainId, expected, name, proxy, registry } = params;

  const isEnabled = useMemo(
    () => !_.isNilOrEmptyString(name) && !_.isNilOrEmptyString(proxy),
    [name, proxy],
  );

  const { data, isLoading } = useQuery<boolean>({
    queryKey: [...REQUEST_ID.plugin, { unique: `${proxy}-${name}-${chainId}` }],
    queryFn: async () =>
      Plugin.isInstalled({
        chainId,
        expected,
        name: params.name,
        proxy: params.proxy!,
        registry,
      }),
    staleTime: QUERY_CACHE_TIME,
    cacheTime: QUERY_CACHE_TIME,
    retry: false,
    enabled: isEnabled,
  });

  return {
    isAvailable: data,
    isLoading: !isEnabled ? false : isLoading,
  };
}
